import { BaseRouteService } from "core/services";

class FacilityHistoryRouteService extends BaseRouteService {
	constructor() {
		super("facility-histories");	
	}	
	
	find(filter) {
		return super.find(`${this.base}/{?searchQuery,page,rpp,sort,embed,fields,facilityId,historyEventTypeId,dateFrom,dateTo}`, filter);
	}	
}

export default FacilityHistoryRouteService;